/*
 * Project: LegalPlace assistant
 * File: src/components/side_menu.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/


import React, { Component } from 'react';
import { connect } from 'react-redux';
import lpApp from '../app/lp_app';
import { redirectToSection } from '../redux/actions/contract';
import { unraiseError } from '../errors/error';
import DefaultValues from '../logic/default_values';

class _LpSideMenu extends Component {
  componentDidMount() {
    const wizardObserver = new MutationObserver(() => {
      function getElHeight(el) {
        if (el) {
          return el.offsetHeight;
        }
        return '0';
      }
      const wizard = document.querySelector('.wizard');

      const asideList = document.querySelector('.forcing-summary ul');

      if (asideList) {
        asideList.style.height = `${wizard ? getElHeight(wizard) : '0'}px`;
      }
    });
    wizardObserver.observe(document.querySelector('.wizard-content'), { childList: true, subtree: true });

    if(document.body.offsetWidth <= 1023 ) {
      document.querySelector('#mysummary').style.display = "none";
    }

  }

  componentDidUpdate() {
    const wizard = document.querySelector('.wizard');
    const asideList = document.querySelector('.forcing-summary ul');

    function getElHeight(el) {
      return el.offsetHeight;
    }
    if (asideList) {
      asideList.style.height = `${wizard ? getElHeight(wizard) : '0'}px`;
    }
    _LpSideMenu.setActualSection(parseInt(this.props.actual_section, 10));
  }

  // When changing the section the menu appears to be reselected.
  static setActualSection(element) {
    const index = document.querySelector(`#menu_s_${element}`);
    if (lpApp.env.is_mobile || lpApp.env.client_zone.width < 600) {
      let y = _LpSideMenu.getYOfMenu(element);
      if (index.offsetHeight > 48) {
        y -= (index.offsetHeight - 48);
        document.body.style.paddingTop = `${-(index.offsetHeight - 48)}px`;
      } else {
        document.body.style.paddingTop = '0px';
      }
      document.querySelector('#innerSum').style.marginTop = `-${y}px`;
      document.querySelector('#mysummary').style.height = `${index.offsetHeight}px`;
    }
    const innerSumLi = [].slice.call(document.querySelectorAll('#innerSum>li'));
    innerSumLi.forEach(idx => idx.classList.remove('active'));
    index.classList.toggle('active');
  }

  static getYOfMenu(i) {
    let result = 0;
    for (let idx = 1; idx <= i; idx += 1) {
      result += document.querySelector(`#menu_s_${idx}`).offsetHeight;
    }
    return result;
  }

  menuSelected(element) {
    const index = document.querySelector(`#menu_s_${element}`);
    if (lpApp.env.is_mobile || lpApp.env.client_zone.width < 600) {
      if (document.querySelector('#mysummary').classList.contains('closed')) {
        document.querySelector('#mysummary').scrollTo(parseInt(document.querySelector('#innerSum').style.marginTop, 10), 0);
        document.querySelector('#innerSum').style.marginTop = 0;
        document.querySelector('#mysummary').classList.remove('closed');
        document.querySelector('#mysummary').style.height = '600px';
        return;
      }
    }
    document.querySelector('#mysummary').scrollTo(0, 0);
    if (lpApp.env.is_mobile || lpApp.env.client_zone.width < 600) {
      let y = _LpSideMenu.getYOfMenu(element);
      if (index.offsetHeight > 48) {
        y -= (index.offsetHeight - 48);
        document.body.style.paddingTop = `${-(index.offsetHeight - 48)}px`;
      } else {
        document.body.style.paddingTop = '0px';
      }
      document.querySelector('#innerSum').style.marginTop = `-${y}px`;
      document.querySelector('#mysummary').style.height = `${index.offsetHeight}px`;
      document.querySelector('#mysummary').classList.add('closed');
    }
    console.log(element);
    this.props.setSectionRedux(element);

    // Setting default values
    DefaultValues.setDefaults(element);
  }

  render() {
    return (
      <div id="mysummary" className="forcing-summary mysummary closed">
        <div className="fs-heading">Sommaire</div>
        <ul id="innerSum">
          {Object.keys(this.props.sections).map((idx, i) => {
            const index = parseInt(idx, 10) + 1;
            const sectionId = this.props.sections[idx].id;
            const mandatoryVars = lpApp.ops.mandatory.checkMandatoryVariables(sectionId);
            const mandatoryOps = lpApp.ops.mandatory.checkMandatoryOptions(sectionId);
            let isMandatory = false;
            if (mandatoryOps === null && mandatoryVars !== null) isMandatory = mandatoryVars;
            else if (mandatoryOps !== null && mandatoryVars === null) isMandatory = mandatoryOps;
            else if (mandatoryOps !== null && mandatoryVars !== null) {
              isMandatory = mandatoryOps && mandatoryVars;
            } else isMandatory = false;

            return (
              <li key={i} className={` is-force${isMandatory ? ' is-ok' : ''}`} id={`menu_s_${i}`} onClick={() => this.menuSelected(i, sectionId)}>
                <a style={{ cursor: 'pointer' }}>
                  <span>
                    {index < 10 ? `${0}${index}` : index}
                    {' '}
.
                  </span>
                  <div>{this.props.sections[idx].label}</div>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  // TODO: some issues with the update of content, so we do it here,
  const la = lpApp.action_tracker.last_action;
  switch (la) {
    case 'EDIT_OPTION_RADIO_':
    case 'CREATE_CONTRACT':
    case 'SET_SECTION_ID':
    case 'LOAD_OVC':
    case 'SET_FULL_WIDTH':
    case 'EDIT_OPTION_VALUE_':
    case 'ADD_MULTIPLE':
    case 'INIT_OUTPUT_OPTION_':
    case 'REMOVE_DUPLICATE':
    case 'REM_OPTION_DUP':
    case 'REM_VARIABLE_DUP':
      // case 'IC_SET_VARIABLE_':

      if (lpApp.mutex.checkMutex('preview')) {
        const outputs = [];
        Object.keys(lpApp.indexes.real_sections.output_sections).map((idx) => {
          lpApp.ops.content.getOutput(
            lpApp.indexes.real_sections.getOutputSection(idx).options,
            outputs,
          );
        });
        lpApp.indexes.content.updateContent(outputs);
      }
      if (typeof window.p === 'undefined') window.p = true;
      else {
        window.p = !window.p;
      }
      break;
    case 'EDIT_VARIABLE_VALUE_':
      if (typeof window.p === 'undefined') window.p = true;
      else {
        window.p = !window.p;
      }
      break;
    default:
      break;
  }
  return {
    actual_section: state.contract.currentSection,
    sections: lpApp.indexes.real_sections.output_sections,
    loading: state.loading_details.wizard,
    change: window.p,
  };
};

const mapDispatchToProps = dispatch => ({
  setSectionRedux: (sId) => {
    dispatch(redirectToSection(sId));
  },
  doInits: (sId) => {
    lpApp.mutex.setMutex('preview', false);
    dispatch(lpApp.ops.initialization.raNextInit(sId));
  },
});

const mergeProps = (stateProps, dispatchProps) => ({
  actual_section: stateProps.actual_section,
  sections: stateProps.sections,
  loading: stateProps.loading,
  setSectionRedux: (sId) => {
    unraiseError('mandatory');
    dispatchProps.setSectionRedux(sId);
    dispatchProps.doInits(sId);
  },
  change: stateProps.change,
});

const LpSideMenu = connect(mapStateToProps, mapDispatchToProps, mergeProps)(_LpSideMenu);

export default LpSideMenu;



// WEBPACK FOOTER //
// ./src/components/side_menu.js